import React from 'react';
import ContentLoader from 'react-content-loader';

const TestSeriesLoader = () => (
    <div className="card-list">
        <div>
            <ContentLoader
                height={537}
                width={195}
                speed={1}
                primarycolor="#f3f3f3"
                secondarycolor="#ecebeb">

                <rect x="5" y="15" rx="5" ry="5" width="80" height="80"/>

                <rect x="5" y="135" rx="5" ry="5" width="220" height="10"/>

                <rect x="5" y="165" rx="5" ry="5" width="220" height="10"/>

                <rect x="5" y="195" rx="5" ry="5" width="220" height="10"/>

                <rect x="5" y="225" rx="5" ry="5" width="220" height="10"/>

                <rect x="5" y="255" rx="5" ry="5" width="220" height="10"/>

                <rect x="5" y="285" rx="5" ry="5" width="220" height="10"/>

                <rect x="5" y="315" rx="5" ry="5" width="220" height="10"/>

                <rect x="5" y="345" rx="5" ry="5" width="220" height="10"/>

                <rect x="5" y="375" rx="5" ry="5" width="220" height="10"/>

                <rect x="5" y="405" rx="5" ry="5" width="220" height="10"/>

                <rect x="5" y="435" rx="5" ry="5" width="220" height="10"/>

                <rect x="5" y="465" rx="5" ry="5" width="220" height="10"/>

                <rect x="5" y="495" rx="5" ry="5" width="220" height="35"/>
            </ContentLoader>
        </div>
    </div>
);

export default TestSeriesLoader;
